export enum OperatorEnum {
  MCI = '1',
  MTN = '2',
  RIGHTEL = '3',
}
